/**
 * Wspólna lista dodatkowych sprawdzeń kasy (zgody, paczkomat).
 *
 * Walidator pól (`checkout-field-validate.js`) przy submit zbiera błędy pól i wszystkich
 * zarejestrowanych sprawdzeń naraz, więc klient widzi pełną listę braków w jednym kroku (WCAG 3.3.1).
 * Każde sprawdzenie zwraca tablicę `{ el, label, msg }`; `el` dostaje fokus z podsumowania.
 */

const checks = [];

export function registerCheckoutCheck(fn) {
    checks.push(fn);
}

export function runCheckoutChecks() {
    return checks.flatMap((fn) => fn() || []);
}
